export default __webpack_public_path__ + "static/media/card2.7d319fdb.png";